module.exports = __webpack_public_path__ + "img/flora_firstserum_202307.2ba2339f.jpg";